import axios from 'axios';

export default {
    FETCH_EVENTS ({commit, dispatch}, payload){
        return new Promise((resolve, reject) => {
            commit('TOGGLE_LOADING', true);
            // axios.post('login/authenticate', payload)
            axios.get('events')
                .then((response) => {
                    const { data: { data } } = response;
                    localStorage.setItem('events', JSON.stringify(data));
                    commit('SET_EVENTS', data);
                    commit('TOGGLE_LOADING', false);
                    resolve(data);

                })
                .catch((error) => {
                    console.log('action fetch error : ', error);
                    reject(error);
                    commit('TOGGLE_LOADING', false);
                });
        })
    },
  FETCH_ARHIVE_ORDERING ({commit, dispatch}, payload){
    return new Promise((resolve, reject) => {
      commit('TOGGLE_LOADING', true);
      // axios.post('login/authenticate', payload)
      axios.get('events/getArchiveEventsDispOrder')
        .then((response) => {
          const { data: { data } } = response;
          commit('TOGGLE_LOADING', false);
          resolve(data.payload.archive_event_order_id);
        })
        .catch((error) => {
          console.log('action fetch error : ', error);
          reject(error);
          commit('TOGGLE_LOADING', false);
        });
    })
  },
    GETSELECTEDEVENT ({ commit }, eventId) {
        commit('TOGGLE_LOADING', true);
        return axios.get(`/events/getByEventId/${eventId}`).then((response) => {
            commit('TOGGLE_LOADING', false);
            const { data: { data } } = response;
            console.log('event data', data)
            commit('SET_SELECTED_EVENT', data && data[0])
        }, (err) => {
            commit('TOGGLE_LOADING', false);
            console.log('err ', err)
        })
    },
  GETDEMOEVENT ({ commit }) {
    commit('TOGGLE_LOADING', true);
    return axios.get(`/events/loadPrivateEventDemo`).then((response) => {
      commit('TOGGLE_LOADING', false);
      const { data: { data } } = response;
      console.log('event data', data.payload)
      commit('SET_DEMO_EVENT', data.payload)
    }, (err) => {
      commit('TOGGLE_LOADING', false);
      console.log('err ', err)
    })
  },
  GET_EMAIL_TEMPLATE ({ commit }) {
    commit('TOGGLE_LOADING', true);
    return axios.get(`/corporations/getCorpCommunityEmail`).then((response) => {
      commit('TOGGLE_LOADING', false);
      const { data: { data } } = response;
      console.log('template data', data.payload)
      commit('SET_EMAIL_TEMPLATE', data.payload)
    }, (err) => {
      commit('TOGGLE_LOADING', false);
      console.log('err ', err)
    })
  },
    ADD_EVENT({commit, dispatch}, payload){
        return new Promise((resolve, reject) => {
            commit('TOGGLE_LOADING', true);
          console.log("add event payload - 2 : ", payload);
            let formData = new FormData();
            payload.event = JSON.stringify(payload.event);
            formData.append("event", payload.event);
            formData.append("file", payload.file);
            console.log('form data for submission', formData)
            axios.post('events', formData)
                .then((response) => {
                    console.log('ADD_EVENT action fetch response : ', response);
                    const { data: { data } } = response;
                    commit('TOGGLE_LOADING', false);
                    resolve(data);
                })
                .catch((error) => {
                    console.log('ADD_EVENT action fetch error : ', error);
                    reject(error);
                    commit('TOGGLE_LOADING', false);
                });
        })
    },
  UPDATE_ARCHIVE_ORDER ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      commit('TOGGLE_LOADING', true);
      return axios.put(`events/updEventDispOrder`, payload).then((response) => {
        commit('TOGGLE_LOADING', false);
        const { data: { data } } = response;
        // console.log('UPDATE_EXPERT response ', response);
        resolve(data);
      }, (error) => {
        commit('TOGGLE_LOADING', false);
        console.log('UPDATE_EXPERT error ', error);
        reject(error);
      })
    })

  },
    UPDATE_EVENT({commit, dispatch}, payload){
        return new Promise((resolve, reject) => {
            commit('TOGGLE_LOADING', true);
            let formData = new FormData();
            payload.event = JSON.stringify(payload.event);
            formData.append("event", payload.event);
            payload.file.length && formData.append("file", payload.file[0]);
            axios.put('events', formData)
                .then((response) => {
                    const { data: { data } } = response;
                    commit('TOGGLE_LOADING', false);
                    resolve(data);
                })
                .catch((error) => {
                    console.log('ADD_EVENT action fetch error : ', error);
                    reject(error);
                    commit('TOGGLE_LOADING', false);
                });
        })
    },
  UPDATEDEMOEVENT({commit, dispatch}, payload){
    return new Promise((resolve, reject) => {
      console.info('payload for ddemo', payload)
      commit('TOGGLE_LOADING', true);
      axios.post('/events/updatePrivateEventDemo', payload)
        .then((response) => {
          const { data: { data } } = response;
          commit('TOGGLE_LOADING', false);
          resolve(data);
        })
        .catch((error) => {
          console.log('UPDATE_DEMO_EVENT action fetch error : ', error);
          reject(error);
          commit('TOGGLE_LOADING', false);
        });
    })
  },
  UPDATE_EMAIL_TEMPLATE_CORP({commit, dispatch}, payload){
    return new Promise((resolve, reject) => {
      commit('TOGGLE_LOADING', true);
      axios.post('/corporations/updateCorpCommunityEmail', payload)
        .then((response) => {
          const { data: { data } } = response;
          commit('TOGGLE_LOADING', false);
          resolve(data);
        })
        .catch((error) => {
          console.log('UPDATE_EMAIL_TEMPLATE action fetch error : ', error);
          reject(error);
          commit('TOGGLE_LOADING', false);
        });
    })
  },
  FETCH_ALL_ARCHIEVE_EVENTS ({commit, dispatch}, payload){
    return new Promise((resolve, reject) => {
      commit('TOGGLE_LOADING', true);
      // axios.post('login/authenticate', payload)
      axios.get('events/getToneLiveEvents')
        .then((response) => {
          const { data: { data : { payload } } } = response;
          commit('TOGGLE_LOADING', false);
          resolve(payload);

        })
        .catch((error) => {
          console.log('action fetch error : ', error);
          reject(error);
          commit('TOGGLE_LOADING', false);
        });
    })
  },
    DELETE_SELECTED_EVENT ({ commit }, params) {
        return new Promise((resolve, reject) => {
            commit('TOGGLE_LOADING', true);
            axios.delete(`/events/${params.eventId}?isDelete=${params.isDelete}`)
                .then((response) => {
                    commit('TOGGLE_LOADING', false);
                    const { data: { data } } = response;
                    console.log('DELETE_SELECTED_EVENT response ', response);
                    resolve(data);
                })
                .catch((error) => {
                    commit('TOGGLE_LOADING', false);
                    console.log('DELETE_SELECTED_EVENT error ', error);
                    reject(error);
                });
        })

    }
}



// WEBPACK FOOTER //
// ./src/store/modules/events/actions.js